<template>
  <div id="app">
    <ViewData />
  </div>
</template>

<script>
import ViewData from './viewdata.vue';

export default {
  components: {
    ViewData,
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

#app {
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
}

html.tyq-plugin-iframe-root #app,
html.tyq-mobile-root #app {
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  overflow: hidden !important;
}

.app-container {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 旧版缩放逻辑已废弃（ViewData 使用 tyq-mobile-layout 自适应） */
@media screen and (max-width: 768px) {
  .app-container {
    transform: none;
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 480px) {
  .app-container {
    transform: none;
    width: 100%;
    height: 100%;
  }
}
</style>